module.exports = __webpack_public_path__ + "img/section3Tab2Icon1.ae771050.png";